import React, { useEffect } from "react";
import { Box, Card } from "@mui/material";
import useStyles from "./payroll-yearly-data.style";
import {
  MyHrPayrollLineChart,
  MyHrPayrollYearSelector,
  MyHrPayrollYearlyDataTooltip,
} from "my-hr/components";
import { useMyHrPayrollData } from "my-hr/hooks";
import { useOcClientState } from "oc/hooks";

type MyHrPayrollYearlyDataProps = {
  contract: { code: string; startOfContract: string } | undefined;
  onSelectMonth: (month: string) => void;
  onSelectYear: (year: string) => void;
};

export const MyHrPayrollYearlyData = ({
  contract,
  onSelectMonth,
  onSelectYear,
}: MyHrPayrollYearlyDataProps) => {
  const classes = useStyles();
  let now = new Date();
  let currentYear = now.getFullYear().toString();

  const [selectedYear, setSelectedYear] = useOcClientState(
    "selectedPayrollYearToShow",
    currentYear,
  );

  const { data, lastPaycardData } = useMyHrPayrollData({
    year: selectedYear,
    contract: contract?.code ?? "",
  });

  const [goBack, setGoBack] = React.useState(true);

  useEffect(() => {
    if (
      lastPaycardData?.year &&
      lastPaycardData?.year !== selectedYear &&
      goBack
    ) {
      setSelectedYear(lastPaycardData?.year);
      setGoBack(false);
    }
  }, [lastPaycardData?.year, selectedYear, goBack, setSelectedYear]);

  const handleSelectYear = (year: string) => {
    setSelectedYear(year);
  };

  const handleSelectMonth = (month: string) => {
    onSelectYear(selectedYear);
    onSelectMonth(month);
  };

  return (
    <Card
      id="my-hr-payroll-year-selector-data"
      style={{
        marginTop: "30px",
        backgroundColor: "#5e6366",
        color: "white",
        borderRadius: "8px",
        padding: "16px 16px",
      }}
    >
      <MyHrPayrollYearSelector
        year={selectedYear}
        onSelectYear={handleSelectYear}
        contract={contract}
      />
      <Box position="relative">
        <Box height="280px" marginTop="16px">
          <MyHrPayrollLineChart data={data} />
        </Box>
        <Box
          id="payroll-tooltip-diagram"
          marginTop="24px"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          position="absolute"
          bottom="0"
          left="0"
          width="100%"
        >
          {data?.map((item, index) => {
            const label = `${item.month}`;
            return (
              <MyHrPayrollYearlyDataTooltip
                key={`${item.month}-${index}`}
                item={item}
                placement="top"
              >
                <button
                  id={`${item.month}`}
                  type="button"
                  aria-label={label}
                  onClick={() => handleSelectMonth(item.month)}
                  className={classes.hovered}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    height: "280px",
                    cursor: "pointer",
                    borderRadius: "8px",
                    border: "none",
                    padding: 0,
                  }}
                />
              </MyHrPayrollYearlyDataTooltip>
            );
          })}
        </Box>
      </Box>
    </Card>
  );
};

export default MyHrPayrollYearlyData;
